<template>
  <div
    class="cursor-pointer"
    :class="{'d-flex justify-content-center': centerItem}"
    v-b-tooltip.hover="{ variant: 'base' }"
    :title=status.display_name
  >
    <font-awesome-icon
      icon="dollar-sign"
      :style="{color: getColorByStatus}"
    />
  </div>
</template>

<script>
export default {
  props: {
    status: {
      type: Object
    },
    centerItem: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    getColorByStatus () {
      return {
        'new': 'red',
        'invoice_received': 'rgb(255, 143, 0)',
        'paid': 'rgb(67, 160, 71)'

      }[this.status.name]
    }
  }
}
</script>
